import { FC } from "react";

export interface InvoiceUpdateSupplierInfoSummaryBoxProps {
  skipped: number;
  updated: number;
  relinked: number;
  created: number;
}

const InvoiceUpdateSupplierInfoSummaryBox: FC<
  InvoiceUpdateSupplierInfoSummaryBoxProps
> = ({ skipped, updated, relinked, created }) => {
  return (
    <div>
      <p>{updated} matched and updated.</p>
      <p>{relinked} relinked.</p>
      <p>{created} new food created.</p>
      <p>{skipped} skipped or not action taken, yet.</p>
    </div>
  );
};

export default InvoiceUpdateSupplierInfoSummaryBox;
